import Page from 'src/components/page/page';
import useMissionDetails from './mission-details.hook';
import { Box, Container } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import CNLoading from 'src/components/loading-cn/CNLoading';
import MissionForm from './components/mission-form';

export default function MissionDetails() {
  const hook = useMissionDetails();

  return (
    <Page title={hook.isEdit ? 'Editar Missão' : 'Cadastrar Missão'}>
      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading={hook.isEdit ? 'Editar Missão' : 'Cadastrar Missão'}
          links={[]}
        />
        {hook.isLoadingMissionDetails ? (
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
            <CNLoading />
          </Box>
        ) : (
          <MissionForm hook={hook} />
        )}
      </Container>
    </Page>
  );
}
